import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52870025&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=52870025&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52870025",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52870025')) {
      api.createRecord('52870025', component.options)
    } else {
      api.reload('52870025', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52870025&scoped=true", function () {
      api.rerender('52870025', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/6-1-pop-window-1/index.vue"
export default component.exports